module.exports = __webpack_public_path__ + "static/media/plan-C2a-mobile-sc.f26b06da.png";